import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useDispatch } from "react-redux";
import ErrorIcon from "@mui/icons-material/Error";
import { saveLoader } from "../../../redux/slice/loaderNoti";
import {
  useLazyVendorViewQuery,
  useVendorEditMutation,
  useVendorStoreMutation,
} from "../../../redux/api/api";
import ImageCroper from "../../../components/Popup/ImageCroper";
import { noLogo } from "../../../assets/img";

const MerchOccasion = () => {
  const location = useLocation();
  const [data, setData] = useState("");
  const [action, setAction] = useState(false);
  const [croperImage, setCropImage] = useState();
  const [croper, setCroper] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    setData(location?.state?.data);
  }, [location]);

  const type = location?.state?.type;
  console.log(location?.state?.type);

  // RTK QUERY
  const [addVendorApi] = useVendorStoreMutation();
  const [editVendorApi] = useVendorEditMutation();
  const [viewVendorApi] = useLazyVendorViewQuery();

  const [full_img1, setFullImg1] = useState("");
  const [full_img2, setFullImg2] = useState("");
  const [full_img3, setFullImg3] = useState("");
  const [full_img4, setFullImg4] = useState("");
  const [full_img5, setFullImg5] = useState("");
  const [full_img6, setFullImg6] = useState("");
  const [fullImg_Err1, setFullImg_Err1] = useState(false);
  const [fullImg_Err2, setFullImg_Err2] = useState(false);
  const [fullImg_Err3, setFullImg_Err3] = useState(false);
  const [fullImg_Err4, setFullImg_Err4] = useState(false);
  const [fullImg_Err5, setFullImg_Err5] = useState(false);
  const [fullImg_Err6, setFullImg_Err6] = useState(false);

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [buttonName, setButtonName] = useState("");
  const [link, SetLink] = useState("");

  const [nameErr, setNameErr] = useState(false);
  const [descriptionErr, setDescriptionErr] = useState(false);
  const [buttonNameErr, setButtonNameErr] = useState(false);
  const [linkErr, SetLinkErr] = useState(false);

  const [image, setImage] = useState("");
  const [priority, setPriority] = useState("");
  const [pririty_Err, setPrio_Err] = useState(false);

  // const [image, setImage] = useState('');
  const dispatch = useDispatch();
  const [btn, setBtn] = useState(false);

  useEffect(() => {
    setData(location?.state?.data);
  }, [location]);

  const toggleImagePopup = (type, method) => {
    setCroper(!croper);
    if (method == "open") {
      setImage(type);
    }
  };

  useEffect(() => {
    setData(location?.state?.data);
  }, [location]);

  const getView = () => {
    viewVendorApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        let data = res?.setting_detail;
        setFullImg1(data?.image_url);

        if (data?.image1_url) {
          setFullImg2(data?.image1_url);
        }
        if (data?.image2_url) {
          setFullImg3(data?.image2_url);
        }
        if (data?.image3_url) {
          setFullImg4(data?.image3_url);
        }
        if (data?.image4_url) {
          setFullImg5(data?.image4_url);
        }
        if (data?.image5_url) {
          setFullImg6(data?.image5_url);
        }

        //json decode
        let json = JSON.parse(data?.contents);
        console.log("json", json);
        // setClient_Img(data?.image_url);
        setName(json?.name);
        setDescription(json?.description);
        setButtonName(json?.button_name);
        SetLink(json?.link);
        setPriority(json?.priority);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getView();
    }
  }, []);

  // console.log("full_img", full_img);

  const submitHandle = () => {
    if (
      name?.length == 0 ||
      description?.length == 0 ||
      buttonName?.length == 0 ||
      link?.length == 0
    ) {
      setNameErr(true);
      setDescriptionErr(true);
      setButtonNameErr(true);
      SetLinkErr(true);
    } else {
      let formdata = new FormData();
      formdata.append("priority", priority);

      formdata.append("type", 5);

      formdata.append("name", name);
      formdata.append("description", description);
      formdata.append("button_name", buttonName);
      formdata.append("link", link);

      if (full_img1?.name) {
        formdata.append("image", full_img1);
      }

      if (full_img2?.name) {
        formdata.append("image1", full_img2);
      }

      if (full_img3?.name) {
        formdata.append("image2", full_img3);
      }

      if (full_img4?.name) {
        formdata.append("image3", full_img4);
      }

      if (full_img5?.name) {
        formdata.append("image4", full_img5);
      }

      if (full_img6?.name) {
        formdata.append("image5", full_img6);
      }

      setBtn(true);
      dispatch(saveLoader(true));
      if (location?.state?.data?.id) {
        formdata.append("setting_id", location?.state?.data?.id);

        editVendorApi(formdata)
          .unwrap()
          .then((res) => {
            setBtn(false);
            dispatch(saveLoader(false));
            navigate("/merch-occasions");
          })
          .catch((err) => {
            setBtn(false);
            dispatch(saveLoader(false));
            console.log("err", err);
          });
      } else {
        addVendorApi(formdata)
          .unwrap()
          .then((res) => {
            setBtn(false);
            dispatch(saveLoader(false));
            navigate("/merch-occasions");
          })
          .catch((err) => {
            setBtn(false);
            dispatch(saveLoader(false));
            console.log("err", err);
          });
      }
    }
  };

  return (
    <div className="dashRightView p-5 home_section trans">
      {croper && (
        <ImageCroper
          toggleImagePopup={toggleImagePopup}
          setCropImage={setCropImage}
        />
      )}
      <p
        className="f4 fs-sm-14 fs-md-15 fs-lg-16 fs-xl-17 fs-xxl-18 primary mt-0 mb-3 d-flex align-items-center gap-1"
        role={"button"}
        onClick={() => navigate(-1)}
      >
        <KeyboardBackspaceIcon /> Merch Occasion
        {location?.state?.type == "view"
          ? " View"
          : location?.state?.type == "edit"
          ? " Edit"
          : " Add"}{" "}
      </p>
      <div className="w-100 searchField mt-0 bg-white ">
        <div className="w-100 d-flex flex-xxl-row flex-xl-row flex-lg-row flex-column">
          <div className="w-xxl-85 w-xl-85 w-lg-85 w-md-100">
            <div className="w-100 d-flex ac-js mt-3">
              <p className="w-30 f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 primary1">
                Name:<span style={{ color: "#f82a2a" }}>(100words only)</span>
                {type == "add" && type !== "view" && <span>*</span>}
              </p>
              <div className="w-50">
                <input
                  className="w-100 editBtnSelect f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 black rounded-3 mt-2"
                  type="text"
                  placeholder=""
                  value={name?.substring(0, 100)}
                  onChange={(e) => setName(e.target.value)}
                  maxLength={100}
                />

                {name?.length == 0 && nameErr && (
                  <div className="d-flex gap-1 mt-2">
                    <ErrorIcon className="svg_log" />
                    <p className="err-input_log mt-1">Enter Name</p>
                  </div>
                )}
              </div>
            </div>
            <div className="w-100 d-flex ac-js mt-3">
              <p className="w-30 f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 primary1">
                Description:
              </p>

              <div className="w-50">
                <textarea
                  className="w-100 editBtnSelect f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 black rounded-3 mt-2"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  disabled={type == "view" ? true : false}
                />
                {description?.length == 0 && descriptionErr && (
                  <div className="d-flex gap-1 mt-2">
                    <ErrorIcon className="svg_log" />
                    <p className="err-input_log mt-1">Enter Description</p>
                  </div>
                )}
              </div>
            </div>
            <div className="w-100 d-flex ac-js mt-3">
              <p className="w-30 f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 primary1">
                Button Name:{type == "add" && type !== "view" && <span>*</span>}
              </p>
              <div className="w-50">
                <input
                  className="w-100 editBtnSelect f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 black rounded-3 mt-2"
                  type="text"
                  placeholder="Order now"
                  value={buttonName}
                  onChange={(e) => setButtonName(e.target.value)}
                />
                {buttonName?.length == 0 && buttonNameErr && (
                  <div className="d-flex gap-1 mt-2">
                    <ErrorIcon className="svg_log" />
                    <p className="err-input_log mt-1">Enter Button Name</p>
                  </div>
                )}
              </div>
            </div>
            <div className="w-100 d-flex ac-js mt-3">
              <p className="w-30 f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 primary1">
                Button Link:{type == "add" && type !== "view" && <span>*</span>}
              </p>
              <div className="w-50">
                <input
                  className="w-100 editBtnSelect f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 black rounded-3 mt-2"
                  type="text"
                  placeholder="https://dev.merchhq.io/"
                  value={link}
                  onChange={(e) => SetLink(e.target.value)}
                />
                {/* https://dev.merchhq.io/ */}
                {link?.length == 0 && linkErr && (
                  <div className="d-flex gap-1 mt-2">
                    <ErrorIcon className="svg_log" />
                    <p className="err-input_log mt-1">Enter Link</p>
                  </div>
                )}
              </div>
            </div>
            <div className="w-100 d-flex ac-js mt-3">
              <p className="w-30 f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 primary1">
                Image 1 :
                <span style={{ color: "#f82a2a" }}>(302px * 243 px)</span>
                {type == "add" && type !== "view" && <span>*</span>}
              </p>
              <div className="w-50 ">
                <div className="w-50">
                  {type !== "view" && (
                    <input
                      type="file"
                      accept="image/*"
                      className="mb-2"
                      onChange={(e) => setFullImg1(e.target.files[0])}
                    />
                  )}
                  <img
                    src={
                      full_img1?.name
                        ? URL.createObjectURL(full_img1)
                        : full_img1
                        ? full_img1
                        : noLogo
                    }
                    className="imgDashboard"
                    disabled={type == "view" ? true : false}
                  />
                  {full_img1?.length == 0 && fullImg_Err1 && (
                    <div className="d-flex gap-1 mt-2">
                      <ErrorIcon className="svg_log" />
                      <p className="err-input_log mt-1">Upload Image</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="w-100 d-flex ac-js mt-3">
              <p className="w-30 f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 primary1">
                Image 2 :
                <span style={{ color: "#f82a2a" }}>(302px * 243 px)</span>
                {type == "add" && type !== "view" && <span>*</span>}
              </p>
              <div className="w-50 ">
                <div className="w-50">
                  {type !== "view" && (
                    <input
                      type="file"
                      accept="image/*"
                      className="mb-2"
                      onChange={(e) => setFullImg2(e.target.files[0])}
                    />
                  )}
                  <img
                    src={
                      full_img2?.name
                        ? URL.createObjectURL(full_img2)
                        : full_img2
                        ? full_img2
                        : noLogo
                    }
                    className="imgDashboard"
                    disabled={type == "view" ? true : false}
                  />
                  {full_img2?.length == 0 && fullImg_Err2 && (
                    <div className="d-flex gap-1 mt-2">
                      <ErrorIcon className="svg_log" />
                      <p className="err-input_log mt-1">Upload Image</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="w-100 d-flex ac-js mt-3">
              <p className="w-30 f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 primary1">
                Image 3 :
                <span style={{ color: "#f82a2a" }}>(302px * 243 px)</span>
                {type == "add" && type !== "view" && <span>*</span>}
              </p>
              <div className="w-50 ">
                <div className="w-50">
                  {type !== "view" && (
                    <input
                      type="file"
                      className="mb-2"
                      accept="image/*"
                      onChange={(e) => setFullImg3(e.target.files[0])}
                    />
                  )}
                  <img
                    src={
                      full_img3?.name
                        ? URL.createObjectURL(full_img3)
                        : full_img3
                        ? full_img3
                        : noLogo
                    }
                    className="imgDashboard"
                    disabled={type == "view" ? true : false}
                  />
                  {full_img3?.length == 0 && fullImg_Err3 && (
                    <div className="d-flex gap-1 mt-2">
                      <ErrorIcon className="svg_log" />
                      <p className="err-input_log mt-1">Upload Image</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="w-100 d-flex ac-js mt-3">
              <p className="w-30 f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 primary1">
                Image 4 :
                <span style={{ color: "#f82a2a" }}>(302px * 243 px)</span>
                {type == "add" && type !== "view" && <span>*</span>}
              </p>
              <div className="w-50 ">
                <div className="w-50">
                  {type !== "view" && (
                    <input
                      type="file"
                      className="mb-2"
                      accept="image/*"
                      onChange={(e) => setFullImg4(e.target.files[0])}
                    />
                  )}
                  <img
                    src={
                      full_img4?.name
                        ? URL.createObjectURL(full_img4)
                        : full_img4
                        ? full_img4
                        : noLogo
                    }
                    className="imgDashboard"
                    disabled={type == "view" ? true : false}
                  />
                  {full_img4?.length == 0 && fullImg_Err4 && (
                    <div className="d-flex gap-1 mt-2">
                      <ErrorIcon className="svg_log" />
                      <p className="err-input_log mt-1">Upload Image</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="w-100 d-flex ac-js mt-3">
              <p className="w-30 f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 primary1">
                Image 5 :
                <span style={{ color: "#f82a2a" }}>(302px * 243 px)</span>
                {type == "add" && type !== "view" && <span>*</span>}
              </p>
              <div className="w-50 ">
                <div className="w-50">
                  {type !== "view" && (
                    <input
                      type="file"
                      accept="image/*"
                      className="mb-2"
                      onChange={(e) => setFullImg5(e.target.files[0])}
                    />
                  )}
                  <img
                    src={
                      full_img5?.name
                        ? URL.createObjectURL(full_img5)
                        : full_img5
                        ? full_img5
                        : noLogo
                    }
                    className="imgDashboard"
                    disabled={type == "view" ? true : false}
                  />
                  {full_img5?.length == 0 && fullImg_Err5 && (
                    <div className="d-flex gap-1 mt-2">
                      <ErrorIcon className="svg_log" />
                      <p className="err-input_log mt-1">Upload Image</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="w-100 d-flex ac-js mt-3">
              <p className="w-30 f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 primary1">
                Image 6 :
                <span style={{ color: "#f82a2a" }}>(302px * 243 px)</span>
                {type == "add" && type !== "view" && <span>*</span>}
              </p>
              <div className="w-50 ">
                <div className="w-50">
                  {type !== "view" && (
                    <input
                      type="file"
                      accept="image/*"
                      className="mb-2"
                      onChange={(e) => setFullImg6(e.target.files[0])}
                    />
                  )}
                  <img
                    src={
                      full_img6?.name
                        ? URL.createObjectURL(full_img6)
                        : full_img6
                        ? full_img6
                        : noLogo
                    }
                    className="imgDashboard"
                    disabled={type == "view" ? true : false}
                  />
                  {full_img6?.length == 0 && fullImg_Err6 && (
                    <div className="d-flex gap-1 mt-2">
                      <ErrorIcon className="svg_log" />
                      <p className="err-input_log mt-1">Upload Image</p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* <div className="w-100 d-flex ac-js mt-3">
                <p className="w-30 f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 primary1">
                  Status
                </p>
  
                <select
                  placeholder=""
                  className="w-50 editBtnSelect f3 fs-15 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 black rounded-3 mt-2"
                  name=""
                  id=""
                >
                  <option>Active</option>
                  <option>De Active</option>
                </select>
              </div> */}
          </div>
        </div>
      </div>
      <div className="d-flex ac-jb">
        <button
          onClick={() => navigate(-1)}
          className="pointerView cust-btn addbtn ms-1 mt-0 bg-primar text-white f3 fs-11 fs-lg-12 fs-xl-13 fs-xxl-14 px-5 rounded"
        >
          Back
        </button>
        {type !== "view" && (
          <button
            className={`cust-btn addbtn mt-3 ms-1 bg-primar text-white f3 fs-11 fs-lg-12 fs-xl-13 fs-xxl-14 py-2 py-md-2 px-5 rounded ${
              btn && "opacity-50"
            }`}
            onClick={submitHandle}
            disabled={btn ? true : false}
          >
            submit
          </button>
        )}
      </div>
    </div>
  );
};
export default MerchOccasion;
